var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseStringIdDataDto } from '../../../classes/common';
import { VehicleWithNumberOnlyDto } from '../../../classes/vehicle';
import { VehicleModelWithNameOnlyDto } from '../../../classes/vehicle-model';
export class ReservationForPaymentDto extends BaseStringIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.pickUpAt = initializer.pickUpAt;
        this.vehicleModel = initializer.vehicleModel;
        this.reservedVehicle = initializer.reservedVehicle;
        this.customerName1 = initializer.customerName1;
    }
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], ReservationForPaymentDto.prototype, "pickUpAt", void 0);
__decorate([
    Type(() => VehicleModelWithNameOnlyDto),
    __metadata("design:type", VehicleModelWithNameOnlyDto)
], ReservationForPaymentDto.prototype, "vehicleModel", void 0);
__decorate([
    Type(() => VehicleWithNumberOnlyDto),
    __metadata("design:type", Object)
], ReservationForPaymentDto.prototype, "reservedVehicle", void 0);
